import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Plus, Copy } from "@phosphor-icons/react";
import api from "@/lib/api";
import { OWNER } from "@/constants/testIds";

export default function LinksTab() {
  const [links, setLinks] = useState([]);
  const [creators, setCreators] = useState([]);
  const [show, setShow] = useState(false);
  const [form, setForm] = useState({ creator_id: "", campaign: "default" });

  async function load() {
    const [l, c] = await Promise.all([api.get("/links"), api.get("/creators")]);
    setLinks(l.data); setCreators(c.data);
  }
  useEffect(() => { load(); }, []);

  async function create(e) {
    e.preventDefault();
    try {
      await api.post("/links", form);
      toast.success("Link created");
      setShow(false); setForm({ creator_id: "", campaign: "default" });
      load();
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Failed");
    }
  }

  function copy(code) {
    const url = `${window.location.origin}/r/${code}`;
    navigator.clipboard.writeText(url);
    toast.success("Copied");
  }

  const nameByCreator = Object.fromEntries(creators.map(c => [c.id, `${c.display_name} @${c.slug}`]));

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <div>
          <h2 className="display-heading font-black text-3xl">Campaign Links</h2>
          <div className="kbd-label text-white/40 mt-1">GENERATE · TRACK · SHARE</div>
        </div>
        <button onClick={() => setShow(!show)} data-testid={OWNER.createLinkBtn} className="neon-btn px-4 py-2 inline-flex items-center gap-2 kbd-label">
          <Plus size={14} weight="bold" /> NEW LINK
        </button>
      </div>

      {show && (
        <form onSubmit={create} className="card-tactical p-6 grid md:grid-cols-3 gap-3">
          <select required value={form.creator_id} onChange={(e) => setForm({ ...form, creator_id: e.target.value })} data-testid={OWNER.linkCreatorSelect} className="bg-black/60 border border-white/10 px-3 py-2 font-mono text-sm focus:border-neon-cyan outline-none">
            <option value="">Select creator…</option>
            {creators.map(c => <option key={c.id} value={c.id}>{c.display_name} (@{c.slug})</option>)}
          </select>
          <input placeholder="Campaign (e.g. tiktok-oct)" value={form.campaign} onChange={(e) => setForm({ ...form, campaign: e.target.value })} data-testid={OWNER.linkCampaignInput} className="bg-black/60 border border-white/10 px-3 py-2 font-mono text-sm focus:border-neon-cyan outline-none" />
          <button type="submit" data-testid={OWNER.linkSubmit} className="neon-btn px-4 py-2 kbd-label">GENERATE</button>
        </form>
      )}

      <div className="card-tactical overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="kbd-label text-left text-white/50 border-b border-white/10">
              <th className="px-6 py-3">CREATOR</th><th>CAMPAIGN</th><th>CODE</th><th>URL</th><th></th>
            </tr>
          </thead>
          <tbody className="font-mono">
            {links.map(l => (
              <tr key={l.id} className="border-b border-white/5">
                <td className="px-6 py-3 font-sans">{nameByCreator[l.creator_id] || l.creator_id}</td>
                <td className="text-neon-yellow">{l.campaign}</td>
                <td>{l.code}</td>
                <td className="truncate max-w-[280px] text-white/60">{`${window.location.origin}/r/${l.code}`}</td>
                <td className="px-3">
                  <button onClick={() => copy(l.code)} className="ghost-btn px-3 py-1 text-xs inline-flex items-center gap-1 text-white">
                    <Copy size={12} /> COPY
                  </button>
                </td>
              </tr>
            ))}
            {links.length === 0 && <tr><td colSpan={5} className="px-6 py-6 text-white/40">No links yet.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
